import React from "react";
import { LegalLayout } from "./LegalLayout";
import { COMPANY } from "@/lib/company";

export default function IptalIade() {
  return (
    <LegalLayout title="İptal, İade ve Geri Ödeme Koşulları">
      <p>
        {COMPANY.brand}, {COMPANY.legalName} tarafından sunulan bir dijital abonelik hizmetidir.
        Aşağıdaki koşullar 6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler
        Yönetmeliği çerçevesinde düzenlenmiştir.
      </p>

      <h2>Ücretsiz Deneme</h2>
      <ul>
        <li>Yeni kayıt olan işletmeler <strong>7 gün ücretsiz deneme</strong> hakkına sahiptir. Deneme süresinde herhangi bir ücret tahsil edilmez ve kredi kartı bilgisi istenmez.</li>
        <li>Deneme süresi sonunda ücretli bir plan seçilmediği takdirde hizmet otomatik olarak kısıtlanır; herhangi bir borç veya tahsilat oluşmaz.</li>
      </ul>

      <h2>Cayma Hakkı</h2>
      <p>
        Mesafeli Sözleşmeler Yönetmeliği'nin 15/1-(ğ) maddesi uyarınca, <strong>elektronik ortamda anında
        ifa edilen ve tüketiciye anında teslim edilen gayrimaddi (dijital) hizmetlerde cayma hakkı
        bulunmamaktadır.</strong> Plan satın alma işlemiyle birlikte hizmet anında aktifleştiği için,
        ödeme onaylandıktan sonra ilgili dönem için cayma hakkı kullanılamaz. Kullanıcı, satın alma
        sırasında bu durumu açıkça onaylar.
      </p>

      <h2>Abonelik İptali</h2>
      <ul>
        <li>Aboneliğinizi <strong>istediğiniz an</strong> işletme panelinizdeki "Abonelik" sayfasından iptal edebilirsiniz.</li>
        <li>İptal durumunda mevcut ödenmiş dönem sonuna kadar hizmet kullanılmaya devam eder; <strong>bir sonraki dönem için tahsilat yapılmaz.</strong></li>
        <li>Abonelik, otomatik yenileme kapatılmadığı sürece dönem sonunda yenilenir.</li>
      </ul>

      <h2>İade / Geri Ödeme</h2>
      <ul>
        <li>Dijital hizmet anında ifa edildiğinden, satın alınan ve aktifleşen dönem için kural olarak geri ödeme yapılmaz.</li>
        <li>Çift tahsilat, hatalı işlem veya hizmetin tarafımızdan hiç sunulamaması gibi istisnai durumlarda, uygun bulunması hâlinde ödeme aynı ödeme yöntemine iade edilir. Onaylanan iadeler, ödeme kuruluşu ve bankanın süreçlerine bağlı olarak genellikle 7-14 iş günü içinde kart/hesabınıza yansır.</li>
        <li>İade talepleri {COMPANY.phone} veya <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a> üzerinden iletilir.</li>
      </ul>

      <h2>İletişim</h2>
      <p>{COMPANY.legalName} · {COMPANY.address} · Tel: {COMPANY.phone} · E-posta: {COMPANY.email}</p>
    </LegalLayout>
  );
}
